import { Tabs as TabsDefault } from './Tabs';
import { Tab } from './components/Tab';

export const Tabs = Object.assign(TabsDefault, { Tab });
